import React from 'react';
import Reflux from 'reflux';
import {withRouter} from 'react-router';
import {Button} from 'antd';
import {DmsTab, TableView, AdvanceFormNew} from '../../components';
import {openNotice, config} from 'Utils';
import {dmsPurchaseList, taxReturn} from '../../service/reportForm';
import moment from 'moment';
import {fetchChannelList} from "../../service/home";

class CustomerTaxReturnQuery extends Reflux.Component {
    constructor(props) {
        super(props);
        this.channelId = window.sessionStorage.getItem('cur_channelId');
        this.state = {
            channelId: this.channelId,
            opts: ['发票池退货关联报表'],
            key: 0,
            filterBoxVisible: false,
            selectedRowKeys: [],
            rows: [],
            total: 1,
            dateMapTotal: 0,
            searchObj: {
                salesUnitId: '',
                channelCode: '',
                s: 10,
                p: 1
            },
            loading: false,
        };
        this.pageChange = this.pageChange.bind(this);
        this.advanceReset = this.advanceReset.bind(this);
        this.advanceSubmit = this.advanceSubmit.bind(this);
        this.setFilterParam = this.setFilterParam.bind(this);
    }

    onSelectChange = (selectedRowKeys) => {
        this.setState({selectedRowKeys});
    }


    advanceReset() {
        let self = this;
        self.setState({
            filterBoxVisible: false,
            searchObj: {
                salesUnitId: '',
                channelCode: '',
                s: 10,
                p: 1
            }
        });
    };

    advanceSubmit(form) {
        /* 筛选确认 */
        let self = this;
        this.setState({
            filterBoxVisible: false,
            searchObj: {
                ...this.state.searchObj,
                p: 1
            }
        }, function () {
            self.initData();
        });
    };


    pageChange(page, pageSize) {
        /* 翻页 刷新 */
        let self = this;
        this.setState({searchObj: {...this.state.searchObj, s: pageSize, p: page}}, function () {
            self.initData();
        });
    }

    setFilterParam(name, value) {
        if (name === 'date') {
            this.setState({searchObj: {...this.state.searchObj, startDate: value.from, endDate: value.end}})
        } else {
            if (value == 'ALL') {
                this.setState({searchObj: {...this.state.searchObj, [name]: ''}})
            } else {
                this.setState({searchObj: {...this.state.searchObj, [name]: value}})
            }
        }
    };

    initData() {
        let self = this;
        let searchObj = self.state.searchObj;
        this.setState({
            loading: true
        });
        taxReturn(searchObj).then(function (result) {
            if (result && result.code == 200) {
                self.setState({
                    rows: result.data || [],
                    total: result.total,
                    dateMapTotal: result.dataMap ? result.dataMap.total : 0,
                    loading: false
                });
            } else {
                openNotice('error', '数据获取失败', '');
                self.setState({
                    loading: false
                });
            }
        });
    }

    componentWillMount() {
    }

    componentDidMount() {
        let self = this;
        dmsPurchaseList({channelCode: this.state.channelId, p: 1, s: 100}).then(res => { //购货单位
            if (res.status) {
                let arr = [
                    {
                        text: '全部',
                        value: ''
                    }
                ];
                for (let i = 0; i < res.data.length; i++) {
                    let x = res.data[i];
                    arr.push({
                        text: x.name,
                        value: x.id
                    })
                }
                self.setState({gouxiaoUnitList: arr})
            }
        });
        /*渠道类型*/
        fetchChannelList().then(res => { //渠道
            if (res.status) {
                let arr = [];
                res.data.forEach(x => {
                    arr.push({
                        text: x.name,
                        value: x.code
                    })
                });
                self.setState({channel_type: arr},
                )
            }
        });
    }

    render() {
        const {opts, key, rows, total, searchObj, loading, gouxiaoUnitList, channel_type} = this.state;
        const filterBoxProps = {
            fileds: [
                {
                    name: 'salesUnitId',
                    label: '购货单位',
                    text: '请选择',
                    type: 'select',
                    options: gouxiaoUnitList,
                    defaultValue: searchObj.salesUnitId
                }, {
                    name: 'channelCode',
                    label: '渠道',
                    text: '选择渠道',
                    options: channel_type,
                    type: 'select',
                    defaultValue: searchObj.channelCode
                }
            ],
            handle: this.advanceSubmit,
            reset: this.advanceReset,
            fieldHandle: this.setFilterParam
        };
        const tableViewProps = {
            loading: loading,
            rowKey: 'LINE_ID',
            pageParam: {
                total: total,
                current: searchObj.p,//当前页码
                pageSize: searchObj.s,//当前分页数
                onChange: this.pageChange
            },
            scroll: {x: 3000, y: false},
            columns: [
                {
                    title: '购货单位',
                    dataIndex: 'SALES_UNIT_NAME',
                }, {
                    title: '渠道',
                    dataIndex: 'SALES_CHANNEL',
                }, {
                    title: '物料编码',
                    dataIndex: 'SEGMENT1',
                }, {
                    title: '物料描述',
                    dataIndex: 'ITEM_DESC',
                }, {
                    title: '原订单编号',
                    dataIndex: 'ORDER_NUMBER',
                }, {
                    title: '原出库单号',
                    dataIndex: 'DELIVERY_ID',
                }, {
                    title: '原出库数量',
                    dataIndex: 'ORDERED_QUANTITY',
                }, {
                    title: '原开票数量',
                    dataIndex: 'KP_QUANTITY',
                }, {
                    title: '发票池ID',
                    dataIndex: 'LINE_ID',
                }, {
                    title: '退货编号',
                    dataIndex: 'RETURN_NUMBER',
                }, {
                    title: '退货类型',
                    dataIndex: 'RETURN_TYPE',
                }, {
                    title: '退货日期',
                    dataIndex: 'RETURN_DATE',
                    render: (text, record, index) => {
                        return <div>{moment(text).format("YYYY-MM-DD")}</div>
                    }
                }, {
                    title: '退货状态',
                    dataIndex: 'STATUS',
                }, {
                    title: '下一步',
                    dataIndex: 'NEXT_STATUS'
                }, {
                    title: '产品线',
                    dataIndex: 'PRODUCT_LINE'
                }, {
                    title: '退货数量',
                    dataIndex: 'RETURN_QUANTITY',
                }, {
                    title: '订单反馈1',
                    dataIndex: 'ATTRIBUTE1',
                }, {
                    title: '订单反馈2',
                    dataIndex: 'ATTRIBUTE2',
                }, {
                    title: 'ERP登记日期',
                    dataIndex: 'BOOKED_DATE',
                }, {
                    title: '退货登记数量',
                    dataIndex: 'RETURN_BOOK_QUANTITY',
                }, {
                    title: '退货开票数量',
                    dataIndex: 'RETURN_KP',
                }
            ],
            rows
        };
        return <div>
            <DmsTab options={opts} defaultKey={key}/>
            <div className="advanceForm-box">
                <div className="advanceForm-content">
                    <AdvanceFormNew  {...filterBoxProps} />
                </div>
            </div>
            <div className="dms-table-box">
                <TableView {...tableViewProps} />
            </div>
        </div>
    }
}

export default withRouter(CustomerTaxReturnQuery);



// WEBPACK FOOTER //
// ./src/routes/reportForm/customerTaxReturnQuery.js